<template>
    <v-dialog max-width="800px" v-model="show" dark>
        <v-card>
            <v-card-title class="headline">OSINT Feed</v-card-title>
            <v-card-text>
                <p>
                    Here are the items that have been picked up about the company by automated web scrapers.
                </p>
            </v-card-text>
            <v-card-text>
                <v-card outlined v-for="item in feed" :key="item.title" class="mb-5">
                    <v-card-title v-if="item.title">{{ item.title }}</v-card-title>
                    <v-card-subtitle>Found on Day {{ item.day }}</v-card-subtitle>

                    <v-card-text v-if="item.type == 'text'" v-html="item.content"/>
                    <v-img v-if="item.type == 'image'" :src="item.content"/>
                    <v-img v-if="item.type == 'localimage'" :src="require(`@/assets/${item.content}`)"/>
                    <div v-if="item.type == 'embed'" v-html="item.content"/>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        value: Boolean,
        action: Object
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        ...mapState({
            feed(state) {
                return state.hackerInfo.feed || [];
            }
        })
    }
}
</script>

<style scoped>
    * {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
    }
</style>
